import { css, StyleSheet } from 'aphrodite';
import React, { ComponentProps } from 'react';
import { Avatar2 } from '../../../../web/components/Avatar2';
import { shuffleGray, titles, white } from '../../../../web/styles/colors';
import { shadowSm } from '../../../../web/styles/shadows';

export function CustomerAssistantAvatar({ styles = [], ...props }: React.ComponentProps<typeof Avatar2>) {
	return <Avatar2 styles={[s.avatar, ...styles]} {...props} />;
}

export function CustomerAssistantTitle({
	styles = [],
	...props
}: AphroditeStyled<React.HTMLAttributes<HTMLHeadingElement>>) {
	return <h2 className={css(s.title, ...styles)} {...props} />;
}

export function CustomerAssistantDescription({
	styles = [],
	...props
}: AphroditeStyled<React.HTMLAttributes<HTMLParagraphElement>>) {
	return <p className={css(s.description, ...styles)} {...props} />;
}

export function CustomerAssistantConversationStarters({
	styles = [],
	...props
}: AphroditeStyled<ComponentProps<'div'>>) {
	return <div className={css(s.conversationStarters, ...styles)} {...props} />;
}

export function CustomerAssistantConversationStarterCard({
	styles = [],
	...props
}: AphroditeStyled<ComponentProps<'button'>>) {
	return <button type='button' className={css(s.starterCard, ...styles)} {...props} />;
}

const s = StyleSheet.create({
	avatar: {
		width: 84,
		height: 84,
	},
	title: {
		fontSize: 16,
		fontWeight: 'bold',
		textAlign: 'center',
		color: titles,
		margin: 0,
		padding: 0,
	},
	description: {
		fontSize: 14,
		color: titles,
		padding: 0,
		margin: 0,
	},
	conversationStarters: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(248px, 1fr))',
		gap: 16,
		width: '100%',
	},
	starterCard: {
		fontSize: 14,
		boxSizing: 'border-box',
		padding: `16px 24px`,
		border: `1px solid ${shuffleGray}`,
		display: 'flex',
		justifyContent: 'center',
		gap: 8,
		borderRadius: 12,
		backgroundColor: white,
		boxShadow: shadowSm,
		cursor: 'pointer',
		userSelect: 'none',
		':hover': {
			backgroundColor: '#18181b0d',
		},
	},
});
